import React, { useEffect, useRef, useState } from "react";
import { FaGraduationCap, FaAward } from "react-icons/fa";

/**
 * Course Duration callout for the four main program pages
 * (Business Administration, Cyber Security, Information Technology,
 * Travel & Tourism Management).
 *
 * Displays Certificate (1 Year) and Diploma (2 Years) using the existing
 * custom-pink + gold palette to stay consistent with the page design.
 */
const ProgramDuration = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-10 md:py-14 bg-white overflow-hidden"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div
          className={`text-center mb-8 transform transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-custom-pink leading-tight">
            Course Duration
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full mt-3" />
        </div>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-8 transform transition-all duration-700 delay-200 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
          }`}
        >
          <div className="group relative rounded-2xl border border-gray-200 bg-gradient-to-br from-white to-custom-pink/5 p-6 md:p-8 shadow-sm hover:shadow-lg hover:border-custom-pink/40 transition-all duration-300">
            <div className="flex items-center gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-custom-pink/10 text-custom-pink flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300">
                <FaGraduationCap />
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
                  Certificate
                </p>
                <p className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">
                  1 Year
                </p>
                <p className="text-xs font-semibold text-custom-pink mt-1 tracking-wide">
                  NTA Level 4
                </p>
              </div>
            </div>
          </div>

          <div className="group relative rounded-2xl border border-gray-200 bg-gradient-to-br from-white to-gold/10 p-6 md:p-8 shadow-sm hover:shadow-lg hover:border-gold transition-all duration-300">
            <div className="flex items-center gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-gold/15 text-gold flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300">
                <FaAward />
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
                  Diploma
                </p>
                <p className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">
                  2 Years
                </p>
                <p className="text-xs font-semibold text-gold mt-1 tracking-wide">
                  NTA Level 5 &amp; 6
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramDuration;
